export const jobListings = [
  {
    "id": 1,
    "jobId": 1,
    "company": "TechCorp",
    "logo": "/company-logos/techcorp-1.jpeg",
    "position": "Frontend Developer",
    "role": "Frontend Development",
    "salary": "15-20 LPA",
    "salaryRange": "15-20 LPA",
    "deadline": "2024-04-30",
    "description": "Looking for experienced frontend developers with expertise in React. Must have strong knowledge of modern JavaScript and UI/UX principles.",
    "requirements": ["3+ years experience", "React.js", "TypeScript", "CSS3"],
    "location": "Bangalore, India",
    "type": "Full-time",
    "mode": "Remote",
    "username": "tech",
    "password": "123",
    "Company_name": "TechCorp",
    "HR": "Prince Maurya"
  },
  {
    "id": 2,
    "jobId": 2,
    "company": "CodeSolutions",
    "logo": "/company-logos/codesolutions.jpeg",
    "position": "Backend Developer",
    "role": "Backend Development",
    "salary": "18-22 LPA",
    "salaryRange": "18-22 LPA",
    "deadline": "2024-05-15",
    "description": "Seeking a backend developer with expertise in Node.js and MongoDB. Experience with cloud services is a plus.",
    "requirements": ["4+ years experience", "Node.js", "MongoDB", "AWS"],
    "location": "Hyderabad, India",
    "type": "Full-time",
    "mode": "Hybrid",
    "username": "code",
    "password": "123",
    "Company_name": "CodeSolutions",
    "HR": "Amit Verma"
  },
  {
    "id": 3,
    "jobId": 3,
    "company": "DataSoft",
    "logo": "/company-logos/datasoft.jpeg",
    "position": "Data Scientist",
    "role": "Data Science",
    "salary": "20-25 LPA",
    "salaryRange": "20-25 LPA",
    "deadline": "2024-06-01",
    "description": "Looking for a skilled Data Scientist with experience in Python, ML, and AI applications.",
    "requirements": ["5+ years experience", "Python", "Machine Learning", "TensorFlow"],
    "location": "Pune, India",
    "type": "Full-time",
    "mode": "Remote",
    "username": "data",
    "password": "123",
    "Company_name": "DataSoft",
    "HR": "Sneha Sharma"
  },
  {
    "id": 4,
    "jobId": 4,
    "company": "CloudNet",
    "logo": "/company-logos/cloudnet.jpeg",
    "position": "DevOps Engineer",
    "role": "DevOps",
    "salary": "22-27 LPA",
    "salaryRange": "22-27 LPA",
    "deadline": "2024-05-20",
    "description": "Hiring an experienced DevOps Engineer with expertise in CI/CD pipelines and Kubernetes.",
    "requirements": ["4+ years experience", "Kubernetes", "Docker", "CI/CD"],
    "location": "Mumbai, India",
    "type": "Full-time",
    "mode": "On-site",
    "username": "clou",
    "password": "123",
    "Company_name": "CloudNet",
    "HR": "Rajesh Kumar"
  },
  {
    "id": 5,
    "jobId": 5,
    "company": "CyberShield",
    "logo": "/company-logos/cybershield.jpeg",
    "position": "Cyber Security Analyst",
    "role": "Cyber Security",
    "salary": "19-24 LPA",
    "salaryRange": "19-24 LPA",
    "deadline": "2024-07-10",
    "description": "Seeking an experienced Cyber Security Analyst to handle security audits and vulnerability assessments.",
    "requirements": ["5+ years experience", "Penetration Testing", "SIEM", "Network Security"],
    "location": "Chennai, India",
    "type": "Full-time",
    "mode": "Hybrid",
    "username": "cybe",
    "password": "123",
    "Company_name": "CyberShield",
    "HR": "Neha Agarwal"
  },
  {
    "id": 6,
    "jobId": 6,
    "company": "TechGuard",
    "logo": "/company-logos/techguard.jpeg",
    "position": "Security Engineer",
    "role": "Cyber Security",
    "salary": "15-20 LPA",
    "salaryRange": "15-20 LPA",
    "deadline": "2024-06-30",
    "description": "Looking for a Security Engineer to conduct security assessments and implement risk mitigation strategies.",
    "requirements": ["3+ years experience", "Network Security", "SIEM", "Threat Intelligence"],
    "location": "Bangalore, India",
    "type": "Full-time",
    "mode": "Remote",
    "username": "techg",
    "password": "123",
    "Company_name": "TechGuard",
    "HR": "Amit Sharma"
  },
  {
    "id": 7,
    "jobId": 7,
    "company": "InfoSecure",
    "logo": "/company-logos/infosecure.jpeg",
    "position": "SOC Analyst",
    "role": "Cyber Security",
    "salary": "12-18 LPA",
    "salaryRange": "12-18 LPA",
    "deadline": "2024-07-05",
    "description": "Hiring a SOC Analyst to monitor and analyze security events to prevent cyber threats.",
    "requirements": ["2+ years experience", "SIEM", "Incident Response", "Log Analysis"],
    "location": "Mumbai, India",
    "type": "Full-time",
    "mode": "Hybrid",
    "username": "info",
    "password": "123",
    "Company_name": "InfoSecure",
    "HR": "Rohit Verma"
  },
  {
    "id": 8,
    "jobId": 8,
    "company": "DataFort",
    "logo": "/company-logos/datafort.jpeg",
    "position": "Ethical Hacker",
    "role": "Cyber Security",
    "salary": "18-22 LPA",
    "salaryRange": "18-22 LPA",
    "deadline": "2024-08-01",
    "description": "Seeking a skilled Ethical Hacker to conduct penetration testing and security evaluations.",
    "requirements": ["4+ years experience", "Ethical Hacking", "Penetration Testing", "OSCP Certification"],
    "location": "Delhi, India",
    "type": "Full-time",
    "mode": "Onsite",
    "username": "dataf",
    "password": "123",
    "Company_name": "DataFort",
    "HR": "Sneha Kapoor"
  },
  {
    "id": 9,
    "jobId": 9,
    "company": "SecureNet",
    "logo": "/company-logos/securenet.jpeg",
    "position": "Cloud Security Engineer",
    "role": "Cyber Security",
    "salary": "20-25 LPA",
    "salaryRange": "20-25 LPA",
    "deadline": "2024-07-15",
    "description": "Hiring a Cloud Security Engineer to design and implement secure cloud architectures.",
    "requirements": ["5+ years experience", "AWS Security", "Cloud Security", "IAM"],
    "location": "Hyderabad, India",
    "type": "Full-time",
    "mode": "Hybrid",
    "username": "secu",
    "password": "123",
    "Company_name": "SecureNet",
    "HR": "Arjun Mehta"
  },
  {
    "id": 10,
    "jobId": 10,
    "company": "CyberShield",
    "logo": "/company-logos/cybershield.jpeg",
    "position": "Cyber Security Analyst",
    "role": "Cyber Security",
    "salary": "19-24 LPA",
    "salaryRange": "19-24 LPA",
    "deadline": "2024-07-10",
    "description": "Seeking an experienced Cyber Security Analyst to handle security audits and vulnerability assessments.",
    "requirements": ["5+ years experience", "Penetration Testing", "SIEM", "Network Security"],
    "location": "Chennai, India",
    "type": "Full-time",
    "mode": "Hybrid",
    "username": "cybe",
    "password": "123",
    "Company_name": "CyberShield",
    "HR": "Neha Agarwal"
  },
  {
    "id": 11,
    "jobId": 11,
    "company": "TrustVault",
    "logo": "/company-logos/trustvault.jpeg",
    "position": "Incident Response Analyst",
    "role": "Cyber Security",
    "salary": "14-18 LPA",
    "salaryRange": "14-18 LPA",
    "deadline": "2024-07-20",
    "description": "Looking for an Incident Response Analyst to handle cybersecurity incidents and provide mitigation strategies.",
    "requirements": ["3+ years experience", "Incident Handling", "Forensics", "SIEM"],
    "location": "Pune, India",
    "type": "Full-time",
    "mode": "Onsite",
    "username": "trus",
    "password": "123",
    "Company_name": "TrustVault",
    "HR": "Ritika Sinha"
  },
  {
    "id": 12,
    "jobId": 12,
    "company": "ShieldTech",
    "logo": "/company-logos/shieldtech.jpeg",
    "position": "Security Architect",
    "role": "Cyber Security",
    "salary": "22-28 LPA",
    "salaryRange": "22-28 LPA",
    "deadline": "2024-07-30",
    "description": "Seeking an experienced Security Architect to design and implement enterprise security strategies.",
    "requirements": ["7+ years experience", "Enterprise Security", "Cloud Security", "Compliance"],
    "location": "Bangalore, India",
    "type": "Full-time",
    "mode": "Remote",
    "username": "shie",
    "password": "123",
    "Company_name": "ShieldTech",
    "HR": "Rajesh Kumar"
  },
  {
    "id": 13,
    "jobId": 13,
    "company": "FortiSec",
    "logo": "/company-logos/fortisec.jpeg",
    "position": "Cyber Threat Analyst",
    "role": "Cyber Security",
    "salary": "16-22 LPA",
    "salaryRange": "16-22 LPA",
    "deadline": "2024-08-10",
    "description": "Hiring a Cyber Threat Analyst to identify and mitigate cyber threats in real time.",
    "requirements": ["4+ years experience", "Threat Intelligence", "Malware Analysis", "SIEM"],
    "location": "Mumbai, India",
    "type": "Full-time",
    "mode": "Hybrid",
    "username": "fort",
    "password": "123",
    "Company_name": "FortiSec",
    "HR": "Megha Reddy"
  },
  {
    "id": 14,
    "jobId": 14,
    "company": "CyberDefend",
    "logo": "/company-logos/cyberdefend.jpeg",
    "position": "Incident Response Specialist",
    "role": "Cyber Security",
    "salary": "18-24 LPA",
    "salaryRange": "18-24 LPA",
    "deadline": "2024-07-25",
    "description": "Looking for an Incident Response Specialist to handle and mitigate cybersecurity incidents.",
    "requirements": ["5+ years experience", "Incident Response", "Forensic Analysis", "SOC Operations"],
    "location": "Delhi, India",
    "type": "Full-time",
    "mode": "Onsite",
    "username": "cybe",
    "password": "123",
    "Company_name": "CyberDefend",
    "HR": "Ankit Sharma"
  },
  {
    "id": 15,
    "jobId": 15,
    "company": "NetSecOps",
    "logo": "/company-logos/netsecops.jpeg",
    "position": "Network Security Engineer",
    "role": "Cyber Security",
    "salary": "14-20 LPA",
    "salaryRange": "14-20 LPA",
    "deadline": "2024-08-05",
    "description": "Hiring a Network Security Engineer to enhance and secure enterprise network infrastructures.",
    "requirements": ["3+ years experience", "Firewall Management", "IDS/IPS", "Network Protocols"],
    "location": "Hyderabad, India",
    "type": "Full-time",
    "mode": "Hybrid",
    "username": "nets",
    "password": "123",
    "Company_name": "NetSecOps",
    "HR": "Vikram Patil"
  }
];
